<template>
  <div v-if="!item.hidden">
    <template
      v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <!-- <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}" @click.native="clickitem">
          <Item :icon="$route.path==resolvePath(onlyOneChild.path) ? (onlyOneChild.meta.select_icon || '') : (onlyOneChild.meta.icon||(item.meta&&item.meta.icon))" :title="item.meta.title" :level="item.meta.level" />
          <svg-icon :icon-class="item.meta.icon" />{{ item.meta.title }}
        </el-menu-item>
      </app-link> -->
      <router-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}" @click.native="clickitem">
          <!-- <item :icon="$route.path==resolvePath(onlyOneChild.path) ? (onlyOneChild.meta.select_icon || '') : (onlyOneChild.meta.icon||(item.meta&&item.meta.icon))" :title="item.meta.title" :level="item.meta.level" :sub-icon="item.meta ? item.meta.subIcon : ''" /> -->
          <svg-icon :icon-class="$route.path==resolvePath(onlyOneChild.path) ? (onlyOneChild.meta.select_icon || '') : (onlyOneChild.meta.icon||((item.meta&&item.meta.icon) || ''))" />
          <el-badge value="新增" :color="'red'" :hidden="isSubMenuHiddenBadge(item)" :offset="[10, 15]">
            {{ item.meta ? item.meta.title : '' }}
          </el-badge>
          <svg-icon v-if="item.meta.subIcon" class="sub-icon" :icon-class="item.meta.subIcon" />
        </el-menu-item>
      </router-link>
    </template>

    <el-sub-menu v-else-if="parentHasAccess(item)" ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template #title>
        <!-- <Item v-if="item.meta" :class-name="userCenterStyle(item.meta)" :icon="item.meta ? item.meta.icon : ''" :title="item.meta.title" :level="item.meta.level" /> -->
        <svg-icon :icon-class="item.meta ? (item.meta.icon || '') : ''" />
        <el-badge is-dot :color="'red'" :hidden="isRootMenuHiddenBadge(item)" :offset="[8, 20]">
          {{ item.meta.title }}
        </el-badge>
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child"
        :base-path="resolvePath(child.path)" class="nest-menu">
      </sidebar-item>
    </el-sub-menu>
  </div>
</template>

<script>

// import store from '@/store'
import { isExternal } from '@/utils/validate'
// import Item from './Item.vue'
// import AppLink from './Link.vue'
import FixiOSBug from './FixiOSBug.js'
import { hasAccess } from '../../../router/permission'

export default {
  name: 'SidebarItem',
  // components: { AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    this.customerCentre = ['账号信息', '贸易公司信息', '商品信息']
    this.carnet = ['进口报关', '出口报关', '报关详情']
    this.staff = ['员工管理', '角色管理', '口岸管理', '添加员工']
    this.clearance = ['出口异常', '进口异常', '创建异常']
    this.defaultIcon = {
      customsClearanceSupply: 'clearance-choose',
      VIPcenter: 'VIPcenter'
    }
    return {
      badgeDit: {
        exportBNewSubmitCount: 0,
        exportBReSubmitCount: 0,
        exportCNewSubmitCount: 0,
        exportCReSubmitCount: 0,
        exportDNewSubmitCount: 0,
        exportDReSubmitCount: 0,
        importBNewSubmitCount: 0,
        importBReSubmitCount: 0,
        importCNewSubmitCount: 0,
        importCReSubmitCount: 0,
        importDNewSubmitCount: 0,
        importDReSubmitCount: 0
      }
    }
  },
  computed: {
    userCenterStyle() {
      return (item) => {
        if (item.icon === 'VIPcenter' || item.icon === 'VIPcenterfalse') {
          return 'userCenterStyle'
        }
      }
    },
    isRootMenuHiddenBadge: function() {
      return (val) => {
        const badgeDitKeys = Object.keys(this.badgeDit)
        const notZeroArray = badgeDitKeys.filter(key => {
          return this.badgeDit[key] !== 0
        })
        if (val.name === 'admin-customs-clearance' && notZeroArray.length > 0) {
          return false
        }
        if (val.name === 'admin-clearance-export' &&
        (this.badgeDit.exportBNewSubmitCount !== 0 || this.badgeDit.exportBReSubmitCount !== 0 ||
        this.badgeDit.exportCNewSubmitCount !== 0 || this.badgeDit.exportCReSubmitCount !== 0 ||
        this.badgeDit.exportDNewSubmitCount !== 0 || this.badgeDit.exportDReSubmitCount !== 0)) {
          return false
        }
        if (val.name === 'admin-clearance-import' &&
        (this.badgeDit.importBNewSubmitCount !== 0 || this.badgeDit.importBReSubmitCount !== 0 ||
        this.badgeDit.importCNewSubmitCount !== 0 || this.badgeDit.importCReSubmitCount !== 0 ||
        this.badgeDit.importDNewSubmitCount !== 0 || this.badgeDit.importDReSubmitCount !== 0)) {
          return false
        }
        return true
      }
    },
    isSubMenuHiddenBadge: function() {
      return (val) => {
        if (val.name === 'admin-clearance-export-b' && (this.badgeDit.exportBNewSubmitCount !== 0 || this.badgeDit.exportBReSubmitCount !== 0)) {
          return false
        }
        if (val.name === 'admin-clearance-export-c' && (this.badgeDit.exportCNewSubmitCount !== 0 || this.badgeDit.exportCReSubmitCount !== 0)) {
          return false
        }
        if (val.name === 'admin-clearance-export-d' && (this.badgeDit.exportDNewSubmitCount !== 0 || this.badgeDit.exportDReSubmitCount !== 0)) {
          return false
        }
        if (val.name === 'admin-clearance-import-b' && (this.badgeDit.importBNewSubmitCount !== 0 || this.badgeDit.importBReSubmitCount !== 0)) {
          return false
        }
        if (val.name === 'admin-clearance-import-c' && (this.badgeDit.importCNewSubmitCount !== 0 || this.badgeDit.importCReSubmitCount !== 0)) {
          return false
        }
        if (val.name === 'admin-clearance-import-d' && (this.badgeDit.importDNewSubmitCount || this.badgeDit.importDReSubmitCount !== 0)) {
          return false
        }
        return true
      }
    }
  },
  created() {
    const route = this.$route
    const { meta } = route
    if (meta && meta.title) {
      this.clickitem(meta.title)
    }
    this.$bus.$on('update-admin-clearance-add-count', (val) => {
      // 更新新增数量
      this.badgeDit = val
    })
  },
  methods: {
    clickitem(e) {
      // const text = e.target ? e.target.innerText : e
      // const data = {
      //   title: '',
      //   icon: ''
      // }
      // if (this.customerCentre.includes(text)) {
      //   data.title = '个人中心'
      //   data.icon = 'VIPcenter'
      // } else if (this.carnet.includes(text)) {
      //   data.title = '报关单证'
      //   data.icon = 'clearance-choose'
      // } else if (this.staff.includes(text)) {
      //   data.title = '平台管理'
      //   data.icon = 'staff'
      // } else if (this.clearance.includes(text)) {
      //   data.title = '清关异常'
      //   data.icon = 'clearance'
      // } else {
      //   data.title = '客户档案'
      //   data.icon = 'profile'
      // }
      // store.commit('permission/CHANGE_ROUTES_ICON', data)
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden || (item.meta && item.meta.permissionTag && !hasAccess(item.meta.permissionTag))) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      if (parent.meta && parent.meta.permissionTag && !hasAccess(parent.meta.permissionTag)) {
        return false
      }

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return false
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      // 浏览器兼容的路径拼接
      if (routePath.startsWith('/')) return routePath
      if (this.basePath.endsWith('/')) return this.basePath + routePath
      return this.basePath + '/' + routePath
    },
    parentHasAccess(parent) {
      return parent.children && parent.children.filter(v => !v.hidden)
        .filter(v => !(v.meta && v.meta.permissionTag && !hasAccess(v.meta.permissionTag))).length > 0
    }
  }
}
</script>

<style lang="scss">
  .el-sub-menu .el-menu-item {
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
  }
  .el-sub-menu .userCenterStyle {
    width: 20px !important;
    height: 20px !important;
    margin-right: 12px !important;
    margin-bottom: -2px
  }
  .sub-icon {
    width: 42px !important;
    height: 20px !important;
    margin-left: 10px;
    margin-top: 0px;
  }
</style>
